import * as React from 'react';

import {ConditionalCheckboxInput} from 'shells/form/conditional-checkbox-input';
import {FormField} from 'shells/form/form-field';
import type {ListOptionWithIcon} from 'shells/select-option-components/option-with-icon';

import type {NotifiableAliasType} from 'nutshell-graphql-types';

import {NOTIFIABLE_STATIC_OPTIONS} from '../../../utils/notifiable-options';

import {GraphQLSelectUsers} from '../../../../core/select/graphql-select-users';

type Props = {
    isNotifyUsersOnGoalMet: boolean;
    setIsNotifyUsersOnGoalMet: (arg1: boolean) => void;
    onSelectUsers: (arg1: ListOptionWithIcon[]) => void;
    onClearSelectedUsers: () => void;
    notifiableUserIds: string[];
    notifiableAssignees: NotifiableAliasType[];
};

export function NotifyUsersGoalMet(props: Props) {
    return (
        <FormField innerId='notify-users-goal-met'>
            <div style={{marginTop: '16px'}}>
                <ConditionalCheckboxInput
                    checked={props.isNotifyUsersOnGoalMet}
                    isLarge={true}
                    label='Notify Nutshell user(s) when the goal is met'
                    onChange={(newValue) => props.setIsNotifyUsersOnGoalMet(newValue)}
                >
                    <GraphQLSelectUsers
                        selectedId={undefined}
                        selectedIds={props.notifiableUserIds.concat(props.notifiableAssignees)}
                        onChange={props.onSelectUsers}
                        onClearValue={props.onClearSelectedUsers}
                        noResultsText='No users were found'
                        valueKey='value'
                        labelKey='label'
                        autoBlur={true}
                        staticOptions={NOTIFIABLE_STATIC_OPTIONS}
                    />
                </ConditionalCheckboxInput>
            </div>
        </FormField>
    );
}
